import { render, staticRenderFns } from "./addTemplate.vue?vue&type=template&id=f93500aa&scoped=true"
import script from "./addTemplate.vue?vue&type=script&lang=js"
export * from "./addTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93500aa",
  null
  
)

export default component.exports